<template>
  <div class="app-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-date"></i> 请假类型</span>
      </div>
      <!-- 查询区域 -->
      <el-form
        :model="queryParams"
        :inline="true"
        label-position="right"
        class="demo-form-inline"
        style="margin-bottom: 20px"
      >
        <el-form-item label="请假类型">
          <el-input
            v-model="queryParams.type"
            placeholder="请输入请假类型"
            clearable
            style="width: 250px"
          />
        </el-form-item>
        <el-row>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="handleQuery(1)"
            >搜索</el-button
          >
          <el-button @click="resetQuery">重置</el-button>
          <el-button type="primary" icon="el-icon-plus" @click="openAddDialog"
            >新增</el-button
          >
        </el-row>
      </el-form>

      <el-table
        :data="tableData"
        style="width: 100%"
        border
        :cell-style="{ textAlign: 'center' }"
        :header-cell-style="{
          background: '#f5f7fa',
          color: '#333',
          fontWeight: 'bold',
          textAlign: 'center',
        }"
      >
        <el-table-column label="请假类型" prop="type"></el-table-column>
        <el-table-column label="创建时间" prop="createTime"></el-table-column>
        <el-table-column label="创建人" prop="creatorName"></el-table-column>
        <el-table-column label="操作">
          <template v-slot="scope">
            <el-button size="mini" @click="openEditDialog(scope.row)"
              >编辑</el-button
            >
            <el-button
              size="mini"
              @click="deleteLeaveType(scope.row)"
              type="danger"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页组件 -->
      <pagination-bar
        :total="total"
        :page-size="pageSize"
        :current-page="currentPage"
        @update:pageSize="pageSize = $event"
        @update:currentPage="currentPage = $event"
        @page-change="handleQuery"
      />

      <!-- 新增/编辑弹窗 -->
      <el-dialog
        @close="resetForm"
        :visible.sync="dialogVisible"
        :rules="rules"
        :title="isEdit ? '编辑请假类型' : '新增请假类型'"
        width="500px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <el-form
          :model="currentLeaveType"
          ref="form"
          :rules="rules"
          label-width="100px"
        >
          <el-form-item label="请假类型" prop="type">
            <el-input
              v-model="currentLeaveType.type"
              placeholder="请输入请假类型"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item label="描述" prop="description">
            <el-input
              v-model="currentLeaveType.description"
              placeholder="请输入描述（可选）"
            ></el-input>
          </el-form-item> -->
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="saveLeaveType">
            {{ isEdit ? "更新" : "确 定" }}
          </el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import {
  leaveTypeList,
  leaveTypeAddOrEdit,
  leaveTypeDelete,
} from "@/api/config";
import PaginationBar from "@/components/PaginationBar";

export default {
  components: {
    PaginationBar,
  },
  data() {
    return {
      queryParams: {
        type: "", // 查询条件
      },
      currentPage: 1,
      pageSize: 10,
      total: 0,
      allData: [],
      rules: {
        type: [
          { required: true, message: "请假类型是必填项", trigger: "blur" },
        ],
      },
      tableData: [],
      dialogVisible: false,
      currentLeaveType: {
        type: "",
      },
      isEdit: false, // 新增还是编辑标识
    };
  },
  created() {
    this.handleQuery();
  },
  methods: {
    resetForm() {
      // 重置表单及校验状态
      this.$refs.form.resetFields();
    },
    handleQuery(page) {
      this.currentPage = page || 1;
      const { type } = this.queryParams;
      leaveTypeList({
        type,
        pageNo: this.currentPage,
        pageSize: this.pageSize,
      }).then((res) => {
        this.tableData = res.records;
        this.total = res.total;
        // console.log("res", res,type, this.currentPage, this.pageSize);
      });
    },
    resetQuery() {
      this.queryParams.type = "";
      this.currentPage = 1;
      this.handleQuery();
    },
    openAddDialog() {
      this.isEdit = false; // 设置为新增
      this.currentLeaveType = { type: "" }; // 去除描述字段
      this.dialogVisible = true;
    },
    openEditDialog(row) {
      this.isEdit = true; // 设置为编辑
      this.currentLeaveType = { ...row };
      this.dialogVisible = true;
    },
    saveLeaveType() {
      const params = {};
      if (this.isEdit) {
        params.id = Number(this.currentLeaveType.id); // 编辑哟ID
      }
      params.type = this.currentLeaveType.type;
      leaveTypeAddOrEdit(params).then(() => {
        this.dialogVisible = false;
        this.handleQuery();
        this.$message.success("操作成功");
      });
    },
    deleteLeaveType(row) {
      this.$confirm("确定删除此请假类型?", "删除提示", {
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          leaveTypeDelete({ id: row.id }).then(() => {
            this.$message.success("删除成功！");
            this.handleQuery();
          });
        })
        .catch(() => {
          this.$message.info("取消删除");
        });
    },
  },
};
</script>

<style scoped>
.app-container {
}
.dialog-footer {
  text-align: right;
}
</style>
